if(!customElements.get('madar-buy-now'))customElements.define('madar-buy-now',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  this.ready=true;
  this.form=this.closest('form');
  this.start=this.querySelector('[data-buy-start]');
  this.root=window.Shopify?.routes?.root||'/';
  this.start.addEventListener('click',()=>this.begin());
  const native=this.form?.querySelector('[name="add"]');
  if(native){const sync=()=>{if(!this.busy&&!this.cartAdded)this.start.disabled=native.disabled;};this.observer=new MutationObserver(sync);this.observer.observe(native,{attributes:true,attributeFilter:['disabled']});sync();}
 }
 disconnectedCallback(){this.observer?.disconnect();}
 async begin(){
  if(this.busy)return;
  if(this.cartAdded||this.uncertain){window.location.assign(this.root+'cart');return;}
  if(!window.madarSizeIsReady?.(this.form))return;
  if(!this.form?.reportValidity())return;
  if(this.form.querySelector('[name="add"]')?.disabled||!this.form.querySelector('[name="id"]')?.value)return;
  this.busy=true;
  this.start.disabled=true;
  this.start.setAttribute('aria-busy','true');
  const error=this.querySelector('[data-buy-error]');
  error.hidden=true;
  try{
   const response=await fetch(this.root+'cart/add.js',{method:'POST',body:new FormData(this.form),headers:{Accept:'application/json'}});
   const result=await response.json();
   if(!response.ok){error.textContent=result.description||this.dataset.error;error.hidden=false;return;}
   this.cartAdded=true;
   window.location.assign(this.root+'checkout');
  }catch{this.uncertain=true;error.textContent=this.dataset.error;error.hidden=false;}
  finally{this.busy=false;this.start.disabled=false;this.start.removeAttribute('aria-busy');if(this.cartAdded||this.uncertain)this.start.textContent=this.dataset.review;}
 }
});
